import styled, { css } from 'styled-components';
import { Typography } from '../../ui/Typography';

export const ReadMoreWrapper = styled.div<{ $isPruned: boolean }>`
  width: 100%;
  font-size: 15px;
  line-height: 25px;
  color: #2f1f19;
  font-weight: 400;
  white-space: pre-wrap;
  margin: 0;

  p {
    margin: 0;
  }

  ${({ $isPruned }) =>
    $isPruned &&
    css`
      max-height: 150px;
      margin-bottom: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      line-clamp: 6;
      -webkit-box-orient: vertical;

      article {
        height: fit-content;
      }
    `}
`;

export const ReadMoreButton = styled(Typography)`
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.systemColors.blue};
  cursor: pointer;
`;
